import { ValidationProps } from 'ui';
import { SubscriberGroupsListItem, SubscriberGroupsSearchModel } from './types-store';
import { MergeSubscriberGroupState } from 'app/area/subscriber-groups/shared/merge-subscriber-group/types-store';
import { ComplexValue } from 'app/types-shared';

export const ACTION = {
  CLEAR_LIST: 'SUBSCRIBER_GROUP_LIST:CLEAR_LIST',

  REQUEST_LIST: 'SUBSCRIBER_GROUP_LIST:REQUEST_LIST',
  RECEIVE_LIST: 'SUBSCRIBER_GROUP_LIST:RECEIVE_LIST',
  FAIL_LIST: 'SUBSCRIBER_GROUP_LIST:FAIL_LIST',

  UPDATE_MERGE_SUBSCRIBER_GROUP: 'SUBSCRIBER_GROUP_LIST:UPDATE_MERGE_SUBSCRIBER_GROUP',
  REQUEST_SUBSCRIBER_GROUP_OPTIONS: 'SUBSCRIBER_GROUP_LIST:REQUEST_SUBSCRIBER_GROUP_OPTIONS',
  RECEIVE_SUBSCRIBER_GROUP_OPTIONS: 'SUBSCRIBER_GROUP_LIST:RECEIVE_SUBSCRIBER_GROUP_OPTIONS',
  FAIL_SUBSCRIBER_GROUP_OPTIONS: 'SUBSCRIBER_GROUP_LIST:FAIL_SUBSCRIBER_GROUP_OPTIONS',

  REQUEST_SUBSCRIBER_GROUP_ITEM_DELETE: 'SUBSCRIBER_GROUP_LIST:REQUEST_SUBSCRIBER_GROUP_ITEM_DELETE',
  RECEIVE_SUBSCRIBER_GROUP_ITEM_DELETE: 'SUBSCRIBER_GROUP_LIST:RECEIVE_SUBSCRIBER_GROUP_ITEM_DELETE',
  FAIL_SUBSCRIBER_GROUP_ITEM_DELETE: 'SUBSCRIBER_GROUP_LIST:FAIL_SUBSCRIBER_GROUP_ITEM_DELETE',

  UPDATE_VALIDATION: 'SUBSCRIBER_GROUP_LIST:UPDATE_VALIDATION',
  RESET_VALIDATION: 'SUBSCRIBER_GROUP_LIST:RESET_VALIDATION'
};

export class ClearList {
  public type: string = ACTION.CLEAR_LIST;
  constructor(public requestId: number) { }
}

export class RequestList {
  public type: string = ACTION.REQUEST_LIST;
  constructor(public requestId: number, public model: SubscriberGroupsSearchModel, public clearResults: boolean) { }
}

export class ReceiveList {
  public type: string = ACTION.RECEIVE_LIST;
  constructor(public requestId: number, public list: SubscriberGroupsListItem[], public numberOfResults: number) { }
}

export class FailList {
  public type: string = ACTION.FAIL_LIST;
  constructor(public requestId: number) { }
}

export class UpdateMergeSubscriberGroup {
  public type: string = ACTION.UPDATE_MERGE_SUBSCRIBER_GROUP;
  constructor(public mergeSubscriberGroup: MergeSubscriberGroupState) {
  }
}

export class RequestSubscriberGroupOptions {
  public type: string = ACTION.REQUEST_SUBSCRIBER_GROUP_OPTIONS;
}

export class ReceiveSubscriberGroupOptions {
  public type: string = ACTION.RECEIVE_SUBSCRIBER_GROUP_OPTIONS;
  constructor(public values: ComplexValue<number>[]) { }
}

export class FailSubscriberGroupOptions {
  public type: string = ACTION.FAIL_SUBSCRIBER_GROUP_OPTIONS;
}

export class RequestSubscriberGroupItemDelete {
  public type: string = ACTION.REQUEST_SUBSCRIBER_GROUP_ITEM_DELETE;
  constructor(public id: number) {
  }
}
export class ReceiveSubscriberGroupItemDelete {
  public type: string = ACTION.RECEIVE_SUBSCRIBER_GROUP_ITEM_DELETE;
  constructor(public id: number) {
  }
}

export class FailSubscriberGroupItemDelete {
  public type: string = ACTION.FAIL_SUBSCRIBER_GROUP_ITEM_DELETE;
  constructor(public id: number) {
  }
}

export class UpdateValidation {
  public type: string = ACTION.UPDATE_VALIDATION;
  constructor(public validation: { [key: string]: ValidationProps }) {
  }
}

export class ResetValidation {
  public type: string = ACTION.RESET_VALIDATION;
  constructor(public key: string) {
  }
}
